










import { Prop, Component, Vue } from "vue-property-decorator";
import { acceptServiceInvitation } from "@/api/invitation-api";
import ReceiveInvitation from "./ReceiveInvitation.vue";

@Component({
  components: {
    ReceiveInvitation
  }
})
export default class ReceiveServiceInvitation extends Vue {
  @Prop({ required: true }) inviteCode!: string;

  code: string = "";
  errors: string[] = [];

  async accept() {
    try {
      this.code = await acceptServiceInvitation(this.inviteCode);
      await this.$store.dispatch("initServiceList");
      this.$router.push("/");
    } catch (e) {
      this.errors = e;
    }
  }
}
